export const AUDIT_ACTION_GROUP_TYPES = {
  MEDIA_HANDLING: 'MEDIA_HANDLING',
  CLIENT_DOCUMENT_CREATION: 'CLIENT_DOCUMENT_CREATION',
  PASSPORT_CREATION: 'PASSPORT_CREATION',
} as const;

export type AuditActionGroupType = (typeof AUDIT_ACTION_GROUP_TYPES)[keyof typeof AUDIT_ACTION_GROUP_TYPES];

export interface AuditInterceptedRequestPayload {
  method: string;
  url: string;
  headers: Record<string, string>;
  body: unknown;
}

export interface CreateAuditRequest {
  actionGroupType: AuditActionGroupType;
  request: AuditInterceptedRequestPayload;
}

export const CLIENT_UI_ANOMALY_ISSUE_TYPES = {
  PARTIAL_LOAD: 'partial_load',
  DETAILS_FAILED: 'details_failed',
  CLIENT_FAILED: 'client_failed',
} as const;

export type ClientUiAnomalyIssueType =
  (typeof CLIENT_UI_ANOMALY_ISSUE_TYPES)[keyof typeof CLIENT_UI_ANOMALY_ISSUE_TYPES];

export interface CreateClientUiAnomalyRequest {
  client_id: number;
  issue_type: ClientUiAnomalyIssueType;
  tab: string | null;
  failed_query_keys: string[];
  app_display_version?: string;
  app_build_id?: string;
  user_agent?: string;
  page_url?: string;
  extra?: Record<string, unknown>;
}

export interface CreateClientUiAnomalyResponse {
  id: string;
}
